export default __webpack_public_path__ + "static/media/p5.a5802d0a.jpg";